import React, { Component } from 'react'

export default class Field extends Component {

    state = {
        inputname: "",
        label: "",
        inputType: "",
        inputSizeClass: "",
        options: [],
        value: "",
        index: "",
        readOnly: false,
    }

    componentDidMount() {
        const { inputname, label, inputType, inputSizeClass, options, onChange, value, index, readOnly } = this.props;
        this.setState({
            inputname, label, inputType, inputSizeClass, options, onChange, value, index, readOnly
        })
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            ...prevState,
            ...nextProps
        };
    }

    render() {
        const { inputname, label, inputType, inputSizeClass, options, onChange, value, index, readOnly } = this.props;
        var inputField = undefined;
        switch (inputType) {
            case 'text':
                inputField = <input type={inputType} name={inputname} className="form-control" value={value}
                    disabled={readOnly}
                    onChange={(e) => onChange(inputname, e.target.value, index)} />
                break;
            case 'number':
                inputField = <input type={inputType} name={inputname} className="form-control" value={value}
                    disabled={readOnly}
                    onChange={(e) => onChange(inputname, e.target.value, index)} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()} />
                break;
            case 'select':
                inputField = <select name="" id="" onChange={(e) => onChange(inputname, e.target.value, index)}
                    disabled={readOnly}
                    value={value}
                    className="form-control">
                    <option value="">select</option>
                    {options.map((data, i) => <option value={data.value}>{data.label}</option>)}
                </select>
                break;
            case 'readonly':
                inputField = <input type={inputType} name={inputname} disabled="disabled" className="form-control" />
                break;
            case 'file':
                inputField = <button className="primary upload-btn">
                    <input type={inputType} name={inputname} onChange={(e) => onChange(e)} multiple />
                    <div>{value}</div>
                </button>
                break;
            case 'button':
                inputField = <button className="primary">
                    <div>{value}</div>
                </button>
                break;
            case "checkboxToggle":
                inputField = (
                    <div class={`switch switch-mod`}>
                        <label>
                            <input
                                type="checkbox"
                                class=""
                                name={inputname}
                                value={value}
                                checked={value}
                                disabled={readOnly}
                                onChange={e => onChange(inputname, e.target.checked, index)}
                            />
                            <span class="lever" />
                        </label>
                        {value && <span class="pr-2 font-apply-li">Active</span>}
                        {!value && <span class="pl-2 font-apply-li">In-active</span>}
                    </div>
                )
                break
            default:
                inputField = <input type="name" className="form-control" />
        }
        return (
            <div class="col-md-6 p-0">
                {/* CUSTOMER NAME FIELD START */}
                <div class="row align-items-center">
                    <div class="col-md-auto label-standard-w">
                        <label for="">{label}</label>
                    </div>
                    {/* FIELD */}
                    <div class={["p-0", inputSizeClass].join(" ")}>
                        {/* FIELD NAME: customerName */}
                        {inputField}
                    </div>
                </div>
                {/* CUSTOMER NAME FIELD END */}
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Field/Field.js